import React from 'react'
import moment from 'moment'
import { FiCheckCircle } from 'react-icons/fi'


export default function TransactionInfo({
  trans_id,
  paid_date,
  amount
}) {

  return (

    <>
      {/* DESKTOP */}

      <div className="
        hidden
        md:grid
        md:grid-cols-[1.5fr_1fr_1fr_120px]
        gap-6
        items-center
        px-6
        py-5
        border-b
        border-gray-100
        last:border-b-0
        hover:bg-gray-50
        transition
      ">

        <div className="min-w-0">

          <p className="
            font-mono
            text-sm
            text-gray-700
            truncate
          ">
            {trans_id || '—'}
          </p>

        </div>


        <p className="
          text-sm
          text-gray-500
        ">
          {formatDate(paid_date)}
        </p>


        <p className="
          text-sm
          font-bold
          text-gray-900
        ">
          {formatCurrency(amount)}
        </p>


        <div>

          <span className="
            inline-flex
            items-center
            gap-1.5
            bg-green-50
            text-green-700
            px-2.5
            py-1.5
            rounded-full
            text-xs
            font-bold
          ">

            <FiCheckCircle />

            Paid

          </span>

        </div>

      </div>


      {/* MOBILE */}

      <div className="
        md:hidden
        px-5
        py-5
        border-b
        border-gray-100
        last:border-b-0
      ">

        <div className="
          flex
          justify-between
          items-start
          gap-5
        ">

          <div className="min-w-0">

            <p className="
              text-xs
              text-gray-400
              mb-1
            ">
              Payment
            </p>

            <p className="
              text-lg
              font-bold
              text-gray-900
            ">
              {formatCurrency(amount)}
            </p>

          </div>


          <span className="
            inline-flex
            items-center
            gap-1
            bg-green-50
            text-green-700
            px-2.5
            py-1
            rounded-full
            text-xs
            font-bold
          ">

            <FiCheckCircle />

            Paid

          </span>

        </div>


        <div className="
          mt-4
          flex
          justify-between
          gap-5
          text-sm
        ">

          <div className="min-w-0">

            <p className="
              text-xs
              text-gray-400
            ">
              Reference
            </p>

            <p className="
              font-mono
              text-xs
              text-gray-600
              truncate
              mt-1
            ">
              {trans_id || '—'}
            </p>

          </div>


          <div className="text-right shrink-0">

            <p className="
              text-xs
              text-gray-400
            ">
              Date
            </p>

            <p className="
              text-sm
              font-medium
              text-gray-700
              mt-1
            ">
              {formatDate(paid_date)}
            </p>

          </div>

        </div>

      </div>

    </>
  )
}



function formatCurrency(amount) {

  return new Intl.NumberFormat(
    'en-NG',
    {
      style: 'currency',
      currency: 'NGN',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }
  ).format(
    Number(amount || 0)
  )
}



function formatDate(date) {

  if (!date) {
    return '—'
  }

  return moment(
    date
  ).format(
    'DD MMM YYYY'
  )
}